import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS } from '../constants.js';


export const AvailPage =()=>{
  const now=new Date();
  const [year,setYear]=React.useState(now.getFullYear());
  const [month,setMonth]=React.useState(now.getMonth()+1);
  const [techs,setTechs]=React.useState([]);
  const [avail,setAvail]=React.useState([]);
  const [projects,setProjects]=React.useState([]);
  const [techProjMap,setTechProjMap]=React.useState([]);
  const [selT,setSelT]=React.useState('');
  const [loading,setLoading]=React.useState(false);

  React.useEffect(()=>{api('/technicians').then(setTechs).catch(()=>{});},[]);
  React.useEffect(()=>{
    setLoading(true);
    const qs=selT?`&technician_id=${selT}`:'';
    Promise.all([
      api(`/availability?month=${month}&year=${year}${qs}`),
      api(`/projects?month=${month}&year=${year}`),
      api(`/technician-project-map?month=${month}&year=${year}`)
    ])
      .then(([a,p,tm])=>{setAvail(a);setProjects(p);setTechProjMap(Array.isArray(tm)?tm:[]);})
      .catch(()=>{})
      .finally(()=>setLoading(false));
  },[month,year,selT]);

  const prev=()=>month===1?(setMonth(12),setYear(y=>y-1)):setMonth(m=>m-1);
  const next=()=>month===12?(setMonth(1),setYear(y=>y+1)):setMonth(m=>m+1);

  const availMap=React.useMemo(()=>{
    const m={};avail.forEach(a=>{const d=dayN(a.day);m[`${a.technician_id}-${d}`]=a;});return m;
  },[avail]);

  // Giorni con cantieri attivi (generico, per sfondo violetto)
  const projDays=React.useMemo(()=>{
    const m={};
    (Array.isArray(projects)?projects:(projects?.items||[])).forEach(p=>{
      const s=dayN(p.date_start),e=p.date_end?dayN(p.date_end):s;
      for(let d=s;d<=e;d++){(m[d]=m[d]||[]).push(p.title);}
    });
    return m;
  },[projects]);

  // Mappa tech-specifica: technician_id -> {day -> [titoli cantiere]}
  const techAssigned=React.useMemo(()=>{
    const m={};
    techProjMap.forEach(tp=>{
      const tid=tp.technician_id;
      if(!m[tid])m[tid]={};
      const s=dayN(tp.date_start),e=tp.date_end?dayN(tp.date_end):s;
      for(let d=s;d<=e;d++){(m[tid][d]=m[tid][d]||[]).push(tp.title);}
    });
    return m;
  },[techProjMap]);

  const dim=new Date(year,month,0).getDate();
  const days=Array.from({length:dim},(_,i)=>i+1);
  const dow=d=>{const w=new Date(year,month-1,d).getDay();return w===0?7:w;};
  const isWE=d=>dow(d)>=6;
  const disp=selT?techs.filter(t=>t.id===+selT):techs;

  // Ciclo: libero → non disponibile → ferie → libero
  const toggle=async(tid,day)=>{
    const key=`${tid}-${day}`;
    const ex=availMap[key];
    const ds=`${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}`;
    const nextStatus=!ex?'unavailable':ex.status==='unavailable'?'vacation':null;

    if(nextStatus===null){
      setAvail(p=>p.filter(a=>!(a.technician_id===tid&&dayN(a.day)===day)));
      await api(`/availability/${ex.id}`,'DELETE');
    }else if(ex){
      setAvail(p=>p.map(a=>a.id===ex.id?{...a,status:nextStatus}:a));
      try{await api('/availability','POST',{technician_id:tid,day:ds,status:nextStatus});}
      catch{setAvail(p=>p.map(a=>a.id===ex.id?ex:a));}
    }else{
      const nr={technician_id:tid,day:ds,status:nextStatus,id:'tmp-'+Date.now()};
      setAvail(p=>[...p,nr]);
      try{const sv=await api('/availability','POST',{technician_id:tid,day:ds,status:nextStatus});
        setAvail(p=>p.map(a=>a.id===nr.id?sv:a));}
      catch{setAvail(p=>p.filter(a=>a.id!==nr.id));}
    }
  };

  return(
    <div>
      <div className="page-header">
        <div className="page-title">Disponibilità personale</div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <select className="input" style={{width:190}} value={selT}
            onChange={e=>setSelT(e.target.value)}>
            <option value="">Tutti i tecnici</option>
            {techs.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <div style={{display:'flex',gap:4}}>
            <button className="btn btn-ghost btn-sm" onClick={prev}><Icon name="chevron-left" size={15} color="var(--n500)"/></button>
            <span style={{fontSize:14,color:'var(--n700)',minWidth:130,textAlign:'center',fontWeight:600,display:'flex',alignItems:'center'}}>
              {MONTHS[month]} {year}</span>
            <button className="btn btn-ghost btn-sm" onClick={next}><Icon name="chevron-right" size={15} color="var(--n500)"/></button>
          </div>
        </div>
      </div>
      <div style={{marginBottom:12,fontSize:12,color:'var(--n400)',display:'flex',gap:16,flexWrap:'wrap'}}>
        <span><span className="legend-dot" style={{background:'var(--n100)',border:'1px solid var(--n200)'}}/>Disponibile</span>
        <span><span className="legend-dot" style={{background:'var(--danger)'}}/>Non disponibile</span>
        <span><span className="legend-dot" style={{background:'#F59E0B'}}/>Ferie</span>
        <span><span className="legend-dot" style={{background:'#EDE9FE',border:'1px solid #C4B5FD'}}/>Cantiere attivo</span>
        <span><span className="legend-dot" style={{background:'#D1FAE5',border:'1px solid #6EE7B7'}}/>Assegnato</span>
        <span style={{color:'var(--n300)',fontStyle:'italic'}}>Click per cambiare stato</span>
      </div>
      <div className="card" style={{padding:0,overflowX:'auto'}}>
        {loading?<div className="empty"><Spin/></div>:(
          <table className="avail-table" style={{minWidth:160+dim*30}}>
            <thead>
              <tr>
                <th className="name-col">Tecnico</th>
                {days.map(d=>(
                  <th key={d} style={{background:isWE(d)?'var(--n100)':'var(--n50)',
                    color:isWE(d)?'var(--blue)':'var(--n400)'}}>
                    <div>{d}</div>
                    <div style={{fontSize:9,opacity:.7}}>{['L','M','M','G','V','S','D'][dow(d)-1]}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {disp.map(t=>(
                <tr key={t.id}>
                  <td className="name-col">{t.name}</td>
                  {days.map(d=>{
                    const rec=availMap[`${t.id}-${d}`];
                    const st=rec?.status;
                    const isAssigned=!!techAssigned[t.id]?.[d];
                    const hasPrj=!!projDays[d];
                    const myProjs=techAssigned[t.id]?.[d]||projDays[d];

                    // Priorità: 1.rosso 2.arancione 3.verde(assegnato) 4.violetto(cantiere) 5.disponibile
                    let cls='avail-cell';
                    if(st==='unavailable') cls+=' unavailable';
                    else if(st==='vacation') cls+=' vacation';
                    else if(isAssigned) cls+=' assigned';
                    else if(hasPrj) cls+=' project-day';
                    else cls+=' available';

                    const title=st==='unavailable'?`${t.name} - non disponibile`:
                      st==='vacation'?`${t.name} - in ferie`:
                      isAssigned?`${t.name} - assegnato: ${(techAssigned[t.id][d]||[]).slice(0,2).join(', ')}`:
                      hasPrj?`Cantiere attivo: ${(projDays[d]||[]).slice(0,2).join(', ')}`:
                      `${t.name} - disponibile`;

                    return(
                      <td key={d} style={{padding:3,background:isWE(d)?'var(--n50)':''}}>
                        <div className={cls} onClick={()=>toggle(t.id,d)} title={title}>
                          {st==='unavailable'&&<Icon name="x" size={9} color="#fff" strokeWidth={3}/>}
                          {st==='vacation'&&<Icon name="sun" size={10} color="#fff" strokeWidth={2}/>}
                          {!st&&isAssigned&&<Icon name="clapperboard" size={9} color="#065F46"/>}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
